export default __webpack_public_path__ + "static/media/Buttock.1fbe4364.svg";